// src/hooks/useGymBranding.js
// Lê dados e cores da academia do localStorage e aplica CSS variables
// na tela de login/cadastro.

import { useEffect, useState } from 'react';

const GYM_REF_KEY = 'LESVITA_GYM_REF';

// CSS variables aplicadas no <html> durante o login/cadastro
const GYM_CSS_VARS = [
  '--gym-branding-primary',
  '--gym-branding-accent',
  '--gym-branding-btn-bg',
  '--gym-branding-btn-text',
  '--gym-branding-navbar-bg',
];

export function useGymBranding() {
  const [gymBranding, setGymBranding] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(GYM_REF_KEY);
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data?.referralCode) return;
      setGymBranding(data);
    } catch {
      // localStorage corrompido — ignora
    }
  }, []);

  // Aplica CSS variables no <html> quando os dados chegam
  useEffect(() => {
    if (!gymBranding) return;

    const root   = document.documentElement;
    const isDark = root.getAttribute('data-theme') === 'dark';

    // Prioriza dark_* se o app estiver em dark mode
    const primary  = (isDark ? gymBranding.darkPrimaryColor  : null) ?? gymBranding.brandPrimaryColor  ?? null;
    const accent   = (isDark ? gymBranding.darkAccentColor   : null) ?? gymBranding.brandAccentColor   ?? null;
    const navbarBg = (isDark ? gymBranding.darkNavbarBgColor : null) ?? null;
    const btnBg    = gymBranding.buttonPrimaryBg   ?? primary ?? null;
    const btnText  = gymBranding.buttonPrimaryText ?? '#ffffff';

    if (primary)  root.style.setProperty('--gym-branding-primary',    primary);
    if (accent)   root.style.setProperty('--gym-branding-accent',     accent);
    if (btnBg)    root.style.setProperty('--gym-branding-btn-bg',     btnBg);
    if (btnText)  root.style.setProperty('--gym-branding-btn-text',   btnText);
    if (navbarBg) root.style.setProperty('--gym-branding-navbar-bg',  navbarBg);

    return () => {
      GYM_CSS_VARS.forEach(v => root.style.removeProperty(v));
    };
  }, [gymBranding]);

  return gymBranding;
}

export default useGymBranding;